<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Cours" />
            <Cours />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import Cours from '../Cours/Cours.vue'

export default {
    name: 'CoursPage',
    components: {
        NavBar,
        PageTitle,
        Cours,
        FooterComp,
    }
}
</script>